module.exports = __webpack_public_path__ + "static/img/img_4.e4a83070.jpg";